import React from "react";
import { Img } from "../..";
import { FiArrowUpRight } from "react-icons/fi";
import { useNavigate } from "react-router-dom";

function InlineOffice({ office = {}, className = "" }) {
	const NAVIGATE = useNavigate();
	const { logo, name, id } = office;

	return (
		<div onClick={() => NAVIGATE(`/app/offices/${id}`)} className="inline-block px-2 py-1 align-middle rounded-md cursor-pointer bg-light hover:bg-primary hover:text-white">
			<div className={`align-center gap-x-1 ${className}`}>
				<Img preview placeholder="https://cdn.travelwings.com/assets/corp/images/placeholders/building.png" src={logo} className="w-4 h-4 rounded-full pixelated" />
				<div className="text-xs">{name}</div>
				<FiArrowUpRight />
			</div>
		</div>
	);
}

export default InlineOffice;
